/* eslint-disable quote-props */
export default {
    'ok': 'Ok',
    'Search': 'Recherche',
    'Address': 'Adresse',
    'Routing': 'Itinéraire',
    'From here': 'Origine',
    'Waypoint here': 'Par ici',
    'Destination here': 'Destination',
    'Distance': 'Distance',
    'Line': 'Ligne',
    'Road': 'Route',
    'Area': 'Zone',
    'fullScreen': 'Plein écran',
    'gasStation': 'Station service',
    'gasstations': 'Stations de service',
    'naturalgasstations': 'Stations de gaz naturel!',
    'electricchargers': 'Stations de recharge électrique',
    'detailedLocation': ' Emplacement détaillé',
    'street': ' Rue',
    'city': ' Localité',
    'postalCode': ' Code postal',
    'municipality': 'Commune',
    'regionLevel2': 'Province',
    'regionLevel1': 'Communauté',
    'country': 'Pays',
    'altitude': 'Altitude',
    'maximumSpeed': 'Vitesse maximale',
    'xy': 'Y,X',
    'copy': 'Copie',
    'go': 'Anar',
    'call': 'Téléphoner',
    'send:': 'Envoyer',
    'calculateIsochrone': 'Calculer isochrone',
    'car': 'Voiture',
    'bicycle': 'Vélo',
    'onFoot': 'A pied',
    'simplified': 'simplifié',
    'detailed': 'détaillé',
    'starting': 'Départ',
    'arrival': 'Arrivée',
    'increments': 'Incréments',
    'maxWeight': ' Poids maximal',
    'maxAxleWeight': 'Poids maximal sur les essieux',
    'maxHeight': 'Hauteur maximale',
    'maxLength': 'Longueur maximale',
    'maxWidth': 'Largeur maximale',
    'maxSpeed': 'vitesse maximale',
    'showRoadRestrictions': 'Voir les restrictions sur la carte',
    'dangerousGoods': 'Marchandises dangereuses',
    'trc': 'Code de restriction du tunnel',
    'trucks': 'Camions',
    'temporalRestrictions': 'Restrictions temporaires',
    'startTime': 'Heure de début',
    'endTime': 'heure de fin',
    'morning': 'Matin',
    'afternoon': 'Après midi',
    'price': 'Prix',
    'schedule': 'Calendrier',
    'font': 'Source',
    'liveTraffic': 'Trafic en direct',
    'forecastTraffic': 'Trafic prévu',
    'slow': 'Lent',
    'fast': 'Vite',
    'roadWorks': 'Travaux routiers',
    'AbnormalTraffic': 'Trafic anormal',
    'queueingTraffic': "Trafic avec files d'attente",
    'slowTraffic': 'Trafic lent',
    'stationaryTraffic': "Trafic à l'arrêt",
    'Accident': 'Accident',
    'accident': 'Accident',
    'EnvironmentalObstruction': 'Obstruction environnementale',
    'flooding': 'Inondation',
    'landslips': 'Glissements de terrain',
    'rockfalls': 'Chutes de pierres',
    'GeneralObstruction': 'Obstruction générale',
    'incident': 'Incident',
    'objectOnTheRoad': 'Objet sur la route',
    'obstructionOnTheRoad': 'Obstruction sur la route',
    'shedLoad': 'Charge perdue',
    'MaintenanceWorks': 'Travaux de maintenance',
    'maintenanceWork': 'Travaux de maintenance',
    'other': 'Autres',
    'resurfacingWork': 'Travaux de resurfaçage',
    'MaintenanceWorks roadworks': 'Travaux de maintenance, travaux routiers',
    'MaintenanceWorks roadworks, maintenanceWork': 'Travaux de maintenance, travaux routiers, travaux de maintenance',
    'roadworks': 'Travaux routiers',
    'roadworks, maintenanceWork': 'Travaux routiers, travaux de maintenance',
    'roadworks, maintenanceWork, resurfacingWork': 'Travaux routiers, travaux de maintenance, travaux de resurfaçage',
    'roadworks, resurfacingWork': 'Travaux routiers, travaux de resurfaçage',
    'NetworkManagement': 'Gestion de réseau',
    'contraflow': 'Contre-flux',
    'intermittentShortTermClosures': 'Fermetures intermittentes de courte durée',
    'laneOrCarriagewayClosed': 'Voie ou chaussée fermée',
    'narrowLanes': 'Voies étroites',
    'restrictions': 'Restrictions',
    'roadClosed': 'Route fermée',
    'singleAlternateLineTraffic': 'Circulation alternée sur une seule voie',
    'VehicleObstruction': 'Obstruction par véhicule',
    'brokenDownVehicle': 'Véhicule en panne',
    'slowMovingMaintenanceVehicle': 'Véhicule de maintenance lent',
    'snowplough': 'Chasse-neige',
    'vehicleOnFire': 'Véhicule en feu',
    'obstruction': 'Obstruction',
    'monday': 'Lundi',
    'tuesday': 'Mardi',
    'wednesday': 'Mercredi',
    'thursday': 'Jeudi',
    'friday': 'Vendredi',
    'saturday': 'Samedi',
    'sunday': 'Dimanche',
    'direction': 'Direction',
    'mapCenter': 'Centre de carte',
    'maxResults': 'Nombre maximum de résultats',
    'maxRadius': 'Rayon maximal',
    'viewOnMap': 'Voir sur la carte',
    'proximity': 'Proximité',
    'selectCategories': 'Sélectionnez les catégories',
    'minimizeRoutingMenu': 'Minimiser le menu de calcul de l\'itinéraire',
    'closeRouteMenu': 'Fermer le menu de calcul de l\'itinéraire',
    'writeOrClickMap': 'Ecrivez ou cliquez sur la carte',
    'routeTo': 'Vers...',
    'waypoint': ' Waypoint ...',
    'addWaypoint': 'Ajouter waypoint',
    'cleanRoute': 'Nettoyer l\'itinéraire',
    'saveRoute': 'Enregistrer l\'itinéraire',
    'printRoute': 'Imprimer la route',
    'modifyRouteOptions': 'Modifier les options d\'itinéraire',
    'logisticsRoute': 'Route pour camions',
    'routeType': 'Type d\'itinéraire',
    'time': 'Temps',
    'restTime': 'Temps de repos',
    'distance': 'Distance',
    'avoidTolls': 'Éviter les péages',
    'realtime': 'Temps réél',
    'optimizedRoute': 'Route optimisée',
    'addedCosts': 'Coûts ajoutés',
    'departureTime': 'Heure de départ',
    'moreDetails': 'Plus de détails',
    'routeCar': 'Trajet en voiture',
    'routeTruck': 'Trajet en camion',
    'withoutTraffic': 'sans trafic',
    'ofRest': 'de repos (tachygraphe)',
    'ZBEInfo': 'Informations sur cette zone à faibles émissions',
    'hour': 'Heure',
    'roadRestrictions': 'Restrictions routières',
    'addBreakTime': 'Ajouter une pause (tachygraphe)',
    'twoDrivers': 'Deux conducteurs',
    'refresh': 'Rafraîchir',
    'disabled': 'Désactivé',
    'sunLight': 'Éclairage du soleil',
    'neighborhoods': 'Quartiers',
    'postalcodes': 'Codes postaux',
    'municipalities': 'Municipalités',
    'routeStopsFrom': ' Origine:',
    'routeStopsThrought': 'waypoint:',
    'routeStopsTo': 'destination:',
    'routeStopsTrafficDelay': 'Délai dû à la circulation actuelle',
    'routeSummaryDetails': 'ITINÉRAIRE DÉTAILLÉ',
    'routeSummaryTraficJam': 'retard',
    'searchAddress': 'Adresse',
    'searchPostalCode': 'Code postal',
    'searchCoordinates': 'Coordonnées',
    'searchLocality': 'Localité',
    'searchPOIs': 'POIs',
    'searchSearchBtn': 'Recherche',
    'searchNearestAddress': 'Adresse la plus proche',
    'searchSelectCountry': 'Sélectionnez un pays',
    'searchAllCountries': 'Tous les pays',
    'searchProjection': 'Projection',
    'searchXCoordinate': 'Coordonnée X',
    'searchYCoordinate': 'Coordonnée Y',
    'searchCandidates': 'Candidats',
    'tooltipAdvancedSearch': 'Recherche avancée',
    'tooltipRouting': 'Calculer l\'itinéraire',
    'tooltipPois': 'POIs',
    'tooltipMeteo': 'Météo',
    'tooltipGasStations': 'Stations-service',
    'tooltipTraffic': 'Circulation',
    'tooltipZBE': 'Zones à faibles émissions',
    'tooltipStreetView': 'Vue sur la rue',
    'tooltipClean': 'Nettoyer la carte',
    'tooltipDraw': 'Dessiner',
    'tooltipLayerSwitcher': 'Modifier la carte',
    'tooltipLayerRegion': 'Ajouter des couches administratives',
    'tooltipLogisticsRestrictions': 'Restrictions routières pour les camions',
    'tooltipIsochrones': 'Calculer les isochrones',
    'tooltipBuildings3D': 'Voir les bâtiments en vue 3D',
    'rainRadar': 'Radar de pluie',
    'notificationRouteCantGetPosition': 'Votre emplacement ne peut pas être obtenu. Entrez l\'adresse sous forme d\'origine.',
    'notificationErrorSavingKML': 'Erreur lors de l\'enregistrement de KML.',
    'notificationErrorGetPostalCode': 'Le code postal ne peut pas être obtenu. Erreur:',
    'notificationControlAlreadyExists': ' Le contrôle existe déjà:',
    'notificationSelectCategories': ' Sélectionnez les catégories de points d\'intérêt en premier.',
    'notificationPoisNotFound': ' Points d\'intérêt non trouvés.',
    'notificationDrawIsochrone': ' Cliquez sur le point de la carte où vous souhaitez calculer l\'isochrone ',
    'notificationErrorGetPathRouting': 'Impossible de trouver le chemin de l\'itinéraire, vérifier les points de passage',
    'assertMapNotDefined': 'Map not defined',
    'assertFeatureExists': 'Feature already exists',
    'assertUnknownBaseLayer': 'Unknown setBaseLayer: ',
    'assertLayerNotSpecified': 'Layer not specified',
    'asserInvalidObjectLonLat': 'Not a \'cercalia.LonLat\' type object',
    'assertUknownWeight': 'Uknown weight: ',
    'assertParameterIsNotFunction': 'Parameter is not a callback function',
    'assertUknownParameter': 'Uknown parameter: ',
    'assertOriginInvalid': 'Can\'t calculate route. Invalid origin: ',
    'assertStepInvalid': 'Can\'t calculate route. Invalid step: ',
    'assertDestinationInvalid': 'Can\'t calculate route. Invalid destination: ',
    'assertProjectionNotDefined': 'Layer projection not declared: ',
    'assertGpsNotPosition': 'Can\'t get GPS position.',
};
//# sourceMappingURL=fr.js.map